"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var client_exports = {};
__export(client_exports, {
  getClient: () => getClient,
  getWorkspaceClient: () => getWorkspaceClient
});
module.exports = __toCommonJS(client_exports);
var import_utils = require("./utils");
function getWorkspaceClient(baseUrl, workspace, token) {
  const client = new Client(baseUrl, token);
  return new WorkspaceClient(client, workspace);
}
__name(getWorkspaceClient, "getWorkspaceClient");
function getClient(baseUrl, token) {
  return new Client(baseUrl, token);
}
__name(getClient, "getClient");
class WorkspaceClient {
  constructor(client, workspace) {
    this.client = client;
    this.workspace = workspace;
  }
  static {
    __name(this, "WorkspaceClient");
  }
  head(key, retryOptions) {
    return this.client.head(this.workspace, key, retryOptions);
  }
  get(key, retryOptions) {
    return this.client.get(this.workspace, key, retryOptions);
  }
  put(key, body, opts, retryOptions) {
    return this.client.put(this.workspace, key, body, opts, retryOptions);
  }
  patch(key, body, opts, retryOptions) {
    return this.client.patch(this.workspace, key, body, opts, retryOptions);
  }
  delete(key, retryOptions) {
    return this.client.delete(this.workspace, key, retryOptions);
  }
  async getJson(key, retryOptions) {
    const res = await this.client.get(this.workspace, key, retryOptions);
    const body = res.ok && res.body != null ? await new Response(res.body).json() : void 0;
    return { ...res, body };
  }
  async putJson(key, json, options, retryOptions) {
    return await this.put(key, JSON.stringify(json), { ...options, mergeStrategy: "jsonpatch" }, retryOptions);
  }
  async patchJson(key, body, options, retryOptions) {
    return await this.patch(
      key,
      JSON.stringify(body),
      { ...options, contentType: "application/json-patch+json" },
      retryOptions
    );
  }
}
class Client {
  constructor(baseUrl, token) {
    this.baseUrl = baseUrl;
    this.token = token;
    this.baseUrl = this.baseUrl.endsWith("/") ? this.baseUrl.slice(0, -1) : this.baseUrl;
  }
  static {
    __name(this, "Client");
  }
  authHeaders(init) {
    const headers = new Headers(init);
    headers.set("Authorization", `Bearer ${this.token}`);
    return headers;
  }
  applyHeaders(h, headers) {
    if (headers != null) for (const [k, v] of Object.entries(headers)) h.set(`teron-header-${k}`, v);
  }
  applyMeta(h, meta) {
    if (meta != null) for (const [k, v] of Object.entries(meta)) h.set(`teron-meta-${k}`, v);
  }
  async status() {
    try {
      const res = await (0, import_utils.fetchSafe)(`${this.baseUrl}/status`);
      return res.ok;
    } catch {
      return false;
    }
  }
  objectUrl(workspace, key) {
    return `${this.baseUrl}/api/${workspace}/${encodeURIComponent(key)}`;
  }
  async head(workspace, key, retryOptions) {
    const res = await (0, import_utils.fetchSafe)(
      this.objectUrl(workspace, key),
      {
        method: "HEAD",
        headers: this.authHeaders()
      },
      retryOptions
    );
    return {
      ok: res.ok,
      status: res.status,
      etag: (0, import_utils.unwrapEtag)(res.headers.get("ETag")),
      lastModified: (0, import_utils.unwrapLastModified)(res.headers.get("Last-Modified")),
      contentType: res.headers.get("Content-Type") ?? "application/octet-stream",
      contentLength: (0, import_utils.unwrapContentLength)(res.headers.get("Content-Length")),
      headers: res.headers
    };
  }
  async get(workspace, key, retryOptions) {
    try {
      const res = await (0, import_utils.fetchSafe)(
        this.objectUrl(workspace, key),
        {
          method: "GET",
          headers: this.authHeaders()
        },
        retryOptions
      );
      return {
        ok: res.ok,
        status: res.status,
        etag: (0, import_utils.unwrapEtag)(res.headers.get("ETag")),
        headers: res.headers,
        lastModified: (0, import_utils.unwrapLastModified)(res.headers.get("Last-Modified")),
        contentType: res.headers.get("Content-Type") ?? "application/octet-stream",
        contentLength: (0, import_utils.unwrapContentLength)(res.headers.get("Content-Length")),
        body: res.ok ? res.body ?? void 0 : void 0
      };
    } catch (err) {
      if (err.name === "NotFoundError") {
        return {
          ok: false,
          status: 404,
          etag: void 0,
          headers: new Headers(),
          body: void 0
        };
      }
      throw err;
    }
  }
  async partial(workspace, key, offset, length, retryOptions) {
    try {
      const res = await (0, import_utils.fetchSafe)(
        this.objectUrl(workspace, key),
        {
          method: "GET",
          headers: this.authHeaders({
            Range: length !== void 0 ? `bytes=${offset}-${offset + length - 1}` : `bytes=${offset}`
          })
        },
        retryOptions
      );
      return {
        ok: res.ok,
        status: res.status,
        etag: (0, import_utils.unwrapEtag)(res.headers.get("ETag")),
        headers: res.headers,
        body: res.ok ? res.body ?? void 0 : void 0
      };
    } catch (err) {
      if (err.name === "NotFoundError") {
        return {
          ok: false,
          status: 404,
          etag: void 0,
          headers: new Headers(),
          body: void 0
        };
      }
      throw err;
    }
  }
  async put(workspace, key, body, opts = {}, retryOptions) {
    const { mergeStrategy, headers, meta } = opts;
    const contentType = "contentType" in opts ? opts.contentType : void 0;
    const contentLength = "contentLength" in opts ? opts.contentLength : void 0;
    const h = this.authHeaders();
    if (mergeStrategy != null) {
      h.set("Teron-Merge-Strategy", mergeStrategy);
    }
    if (contentType != null) {
      h.set("Content-Type", contentType);
    } else if (mergeStrategy === "jsonpatch") {
      h.set("Content-Type", "application/json");
    }
    if (contentLength != null) {
      h.set("Content-Length", contentLength.toString());
    }
    this.applyHeaders(h, headers);
    this.applyMeta(h, meta);
    const duplex = body instanceof ReadableStream ? "half" : void 0;
    const res = await (0, import_utils.fetchSafe)(
      this.objectUrl(workspace, key),
      {
        method: "PUT",
        headers: h,
        body,
        // @ts-expect-error must present for ReadableStream but it is not in the interface
        duplex
      },
      retryOptions
    );
    return {
      ok: res.ok,
      status: res.status,
      etag: (0, import_utils.unwrapEtag)(res.headers.get("ETag")),
      lastModified: (0, import_utils.unwrapLastModified)(res.headers.get("Last-Modified")),
      contentLength: (0, import_utils.unwrapContentLength)(res.headers.get("Content-Length")),
      headers: res.headers
    };
  }
  async patch(workspace, key, body, opts = {}, retryOptions) {
    const { contentType, contentLength, headers, meta } = opts;
    const h = this.authHeaders();
    if (contentType != null) {
      h.set("Content-Type", contentType);
    }
    if (contentLength != null) {
      h.set("Content-Length", contentLength.toString());
    }
    this.applyHeaders(h, headers);
    this.applyMeta(h, meta);
    const duplex = body instanceof ReadableStream ? "half" : void 0;
    const res = await (0, import_utils.fetchSafe)(
      this.objectUrl(workspace, key),
      {
        method: "PATCH",
        headers: h,
        body,
        // @ts-expect-error must present for ReadableStream but it is not in the interface
        duplex
      },
      retryOptions
    );
    return {
      ok: res.ok,
      status: res.status,
      etag: (0, import_utils.unwrapEtag)(res.headers.get("ETag")),
      lastModified: (0, import_utils.unwrapLastModified)(res.headers.get("Last-Modified")),
      contentLength: (0, import_utils.unwrapContentLength)(res.headers.get("Content-Length")),
      contentType: res.headers.get("Content-Type") ?? void 0,
      headers: res.headers
    };
  }
  async delete(workspace, key, retryOptions) {
    const res = await (0, import_utils.fetchSafe)(
      this.objectUrl(workspace, key),
      {
        method: "DELETE",
        headers: this.authHeaders()
      },
      retryOptions
    );
    return {
      ok: res.ok,
      status: res.status,
      headers: res.headers
    };
  }
}
//# sourceMappingURL=client.js.map
